import AuthService from "../../AuthService";
const utility = {
  getPathImage(data) {
    return AuthService.post("/upload_image", data);
  },
  getPathFile(data) {
    return AuthService.post("/upload_file", data);
  }
};
export default utility;
